import { Link } from 'react-router-dom';
import { HStack, Flex } from '@chakra-ui/react';
import { IconWithTextLightLogo } from '@duke-hq/ui/components/Logo/IconWithTextLightLogo';
import { SidebarDrawerAdmin } from '../SidebarAdmin';
import { AdminUserAvatarMenu } from '../components/AdminUserAvatarMenu';
import { sizes } from '@duke-hq/ui/constants/layout';
import { pxToRem } from '@duke-hq/ui/constants/scalable';

export function Navbar() {
  return (
    <Flex
      alignItems="center"
      zIndex={1012}
      h={sizes.navbar}
      bg="bg.surface"
      color="fg.emphasized"
      position="relative"
      className="navbar"
      borderBottomWidth="1px"
      p="2"
    >
      <HStack justify="space-between" spacing="8" h="full" w="full">
        <HStack spacing="2" alignItems="center">
          <SidebarDrawerAdmin />
          <Link to="/">
            <IconWithTextLightLogo h={pxToRem(32)} />
          </Link>
        </HStack>
        <HStack spacing={{ base: '2', md: '4' }}>
          <AdminUserAvatarMenu />
        </HStack>
      </HStack>
    </Flex>
  );
}
